/* eslint-disable react-hooks/exhaustive-deps */
import { Box } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { TextWrapper } from '../../../../../components/formUtilities/useTextWrapper';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { LanguageService } from '../../../../../../services/languageService';
import { AppRoutes } from '../../../../../../constants/appRoutes';
import { SystemSettingsService } from '../../../../../../services/systemSettingsService';
import { useEffect, useState } from 'react';
import { useLayoutScroll } from '../../../layoutScrollContext';
import { buildLocalizeRoute } from '../../../../../../helpers/languageHelper';
import { useFsConfirm } from '../../../../../components/dialog';
import { useTranslation } from 'react-i18next';
import { InvestorService } from '../../../../../../pages/investor/investorService';
import { Observables } from '../../../../../../observables';
import { getUser } from '../../../../../../services/authService';
import { PreventDepositDialog } from '../../../../../../pages/investor/views/transfers/deposit/preventDepositDialog';
import { InvestorStatus } from '../../../../../../constants/investorStatus';
import GridViewOutlinedIcon from '@mui/icons-material/GridViewOutlined';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import TrendingUpOutlinedIcon from '@mui/icons-material/TrendingUpOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import SwapHorizOutlinedIcon from '@mui/icons-material/SwapHorizOutlined';
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';
import NavPillLink from '../../../../../../pages/investor/components/navPillLink';
import AvailableFundsPill from '../../../../../../pages/investor/components/availableFundsPill';
import { useInvestorDetails } from '../../../../../../context/investorDetailContext';
import { InvestorType } from '../../../../../../constants/investorType';

export const SubNavbar = () => {
	const navigate = useNavigate();
	const systemSettingsService = new SystemSettingsService();
	const languageService = new LanguageService();
	const investorService = new InvestorService();
	const location = useLocation();
	const confirm = useFsConfirm();
	const langRoute = languageService.getCurrentLanguage();
	const [availableCash, setAvailableCash] = useState(0);
	const [fundsLoading, setFundsLoading] = useState(true);
	const { t } = useTranslation();
	const [showTransferPopup, setShowTransferPopup] = useState(false);
	const scrolled = useLayoutScroll();
	const isWinddown = getUser()?.status === InvestorStatus.WindDown;
	const { investorDetails } = useInvestorDetails();
	const [subNavLinks, setSubNavLinks] = useState([
		{
			name: t('investorNavbarDashboard'),
			linkTo: '',
			path: AppRoutes.Investor,
			icon: GridViewOutlinedIcon,
			id: 1,
		},
		{
			name: t('marketplace'),
			linkTo: AppRoutes.Marketplace,
			path: `${AppRoutes.Investor}/${AppRoutes.Marketplace}`,
			icon: LanguageOutlinedIcon,
			id: 2,
		},
		{
			name: t('navInvestments'),
			linkTo: AppRoutes.MyInvestments,
			path: `${AppRoutes.Investor}/${AppRoutes.MyInvestments}`,
			icon: TrendingUpOutlinedIcon,
			id: 3,
		},
		{
			name: t('navSettings'),
			linkTo: AppRoutes.InvestmentSettings,
			path: `${AppRoutes.Investor}/${AppRoutes.InvestmentSettings}`,
			icon: SettingsOutlinedIcon,
			id: 4,
		},
		{
			name: t('transfers'),
			linkTo: isWinddown ? `${AppRoutes.ITransfer}/${AppRoutes.IWithdraw}` : AppRoutes.ITransfer,
			path: `${AppRoutes.Investor}/${AppRoutes.ITransfer}`,
			icon: SwapHorizOutlinedIcon,
			id: 5,
		},
	]);

	const hasInvestorDashboardAccess =
		investorDetails?.investorType?.name === InvestorType.Corporate &&
		investorDetails?.integrationEnabled;

	useEffect(() => {
		setSubNavLinks((prev) => {
			const withoutDashboardLink = prev.filter((link) => link.id !== 6);
			if (!hasInvestorDashboardAccess) {
				return withoutDashboardLink;
			}
			const investmentsIndex = withoutDashboardLink.findIndex((link) => link.id === 3);
			const insertAt = investmentsIndex === -1 ? withoutDashboardLink.length : investmentsIndex + 1;
			return [
				...withoutDashboardLink.slice(0, insertAt),
				{
					name: t('investorDashboardNavLabel'),
					linkTo: AppRoutes.InvestorDashboard,
					path: `${AppRoutes.Investor}/${AppRoutes.InvestorDashboard}`,
					icon: BusinessCenterOutlinedIcon,
					id: 6,
				},
				...withoutDashboardLink.slice(insertAt),
			];
		});
	}, [hasInvestorDashboardAccess]);

	const settings = () => {
		return systemSettingsService.systemSettings();
	};

	useEffect(() => {
		getSummaryShort();
	}, [location]);

	useEffect(() => {
		let subNav = subNavLinks;
		if (settings()) {
			subNav.forEach((resp, index) => {
				if (resp.id === 2 && !settings()?.enableMarketplace) {
					subNav.splice(index, 1);
				}
				if (resp.id === 5 && !getUser()?.isApproved && !isWinddown) {
					subNav.splice(index, 1);
				}
			});
		}
		setSubNavLinks([...subNav]);
		getSummaryShort();
		Observables.investorSummaryRefresh.subscribe((resp) => {
			if (resp === 1) {
				setTimeout(() => {
					getSummaryShort();
				}, 2000);

			}
		});
	}, []);

	const getSummaryShort = () => {
		setFundsLoading(true);
		investorService
			.getInvestorSummaryShort()
			.then((resp) => {
				setAvailableCash(resp.data?.availableCash);
			})
			.catch(() => { })
			.finally(() => setFundsLoading(false));
	};

	const isMainPagesActive = () => {
		if (
			window.location.pathname ===
			`/${langRoute}/${AppRoutes.Investor}` ||
			window.location.pathname ===
			`/${langRoute}/${AppRoutes.Investor}/${AppRoutes.ITransfer}/${AppRoutes.ITransferMethods}` ||
			window.location.pathname ===
			`/${langRoute}/${AppRoutes.Investor}/${AppRoutes.ITransfer}/${AppRoutes.IDeposit}` ||
			window.location.pathname ===
			`/${langRoute}/${AppRoutes.Investor}/${AppRoutes.ITransfer}/${AppRoutes.IWithdraw}` ||
			window.location.pathname ===
			`/${langRoute}/${AppRoutes.Investor}/${AppRoutes.ITransfer}/${AppRoutes.ITransactionHistory}` ||
			window.location.pathname ===
			`/${langRoute}/${AppRoutes.Investor}/${AppRoutes.Marketplace}/upcoming` ||
			window.location.pathname ===
			`/${langRoute}/${AppRoutes.Investor}/${AppRoutes.Marketplace}/past` ||
			window.location.pathname ===
			`/${langRoute}/${AppRoutes.Investor}/${AppRoutes.Marketplace}/current` ||
			window.location.pathname ===
			`/${langRoute}/${AppRoutes.Investor}/${AppRoutes.Marketplace}` ||
			window.location.pathname.startsWith(
				`/${langRoute}/${AppRoutes.Investor}/${AppRoutes.Marketplace}/${AppRoutes.MarketplaceBusinessDetails}/`
			) ||
			window.location.pathname ===
			`/${langRoute}/${AppRoutes.Investor}/${AppRoutes.MyInvestments}` ||
			window.location.pathname ===
			`/${langRoute}/${AppRoutes.Investor}/${AppRoutes.InvestmentSettings}` ||
			window.location.pathname ===
			`/${langRoute}/${AppRoutes.Investor}/${AppRoutes.InvestorDashboard}`
		) {
			return true;
		}
		return false;
	};

	const checkIsActive = (relativePath) => {
		if (relativePath === `${AppRoutes.Investor}/${AppRoutes.ITransfer}`) {
			return (
				window.location.pathname.includes(AppRoutes.IDeposit) ||
				window.location.pathname.includes(AppRoutes.IWithdraw) ||
				window.location.pathname.includes(AppRoutes.IPayment) ||
				window.location.pathname.includes(AppRoutes.ITransferMethods) ||
				window.location.pathname.includes(AppRoutes.ITransactionHistory)
			);
		}
		if (relativePath === `${AppRoutes.Investor}/${AppRoutes.Marketplace}`) {
			return window.location.pathname.includes(`/${AppRoutes.Investor}/${AppRoutes.Marketplace}`);
		}
		return (
			`/${langRoute}/${relativePath}` === window.location.pathname
		);
	};

	const onAddFunds = () => {
		if (settings()?.enableDeposits) {
			navigate({
				pathname: `${buildLocalizeRoute(
					`${AppRoutes.Investor}/${AppRoutes.ITransfer}/${AppRoutes.ITransferMethods}`
				)}`,
			});
		} else {
			confirm({
				description: `Funding Souq has paused accepting any
				deposits in the upcoming months. Once we are back,
				we'll email you accordingly. For more information,
				reach out to support@fundingsouq.com`,
				title: 'We Paused Deposits!',
				hideCancelButton: 'true',
				confirmationText: 'Ok',
			})
				.then(() => { })
				.catch(() => console.log('cancelled.'));
		}
	};

	return (
		<Box
			className="h-[52px] items-center w-full !hidden md:!flex bg-white md:mt-[80px] !fixed z-[99] !pb-2"
			sx={{ boxShadow: scrolled ? '0 2px 8px rgba(0,0,0,0.08)' : 'none', transition: 'box-shadow 0.2s ease' }}>
			<Box className="w-full md:px-[72px] px-2 flex items-center justify-between">
				{isMainPagesActive() ? (
					<Box className="flex items-center">
						{subNavLinks.map((navItem, index) => (
							<NavPillLink
								key={index}
								to={navItem.linkTo}
								icon={navItem.icon}
								label={navItem.name}
								isActive={checkIsActive(navItem.path)}
							/>
						))}
					</Box>
				) : (
					<Box
						className="flex items-center text-gray-700 cursor-pointer nav-back-btn"
						onClick={() => {
							if (window.location.pathname.includes(`/${AppRoutes.Profile}/`)) {
								navigate(buildLocalizeRoute(AppRoutes.Investor));
								return;
							}
							navigate(-1);
						}}>
						{languageService.isArabic() ? (
							<ArrowForwardIcon className="nav-back-icon-ar" />
						) : (
							<ArrowBackIcon className="nav-back-icon-en" />
						)}
						<TextWrapper
							classList="!mx-2"
							text={t('back')} />
					</Box>
				)}
				<AvailableFundsPill
					amount={availableCash}
					loading={fundsLoading}
					onClick={() => {
						if (!getUser()?.isApproved) {
							setShowTransferPopup(true);
							return;
						}
						onAddFunds();
					}}
				/>
			</Box>
			{showTransferPopup ?
				<PreventDepositDialog
					onClose={() => {
						setShowTransferPopup(false);
					}} state={showTransferPopup} /> : null}
		</Box>
	);
};
